import React from 'react'
import Home from '../Components/Contact-Us/Home/Home'
import Contact from '../Components/Contact-Us/Contact/Contact'

const ContactPage = () => {
  return (
    <>
        <Home />
        <Contact />
    </>
  )
}

export default ContactPage